import StepCreateKec from '../../../components/new-step-createKec/index.vue'

export default {
    name: 'vmConfig',
    // 继承主机机型选配模块
    extends: StepCreateKec,
    methods: {
        _fetchImageTypeList() {
            let imageTypeList = [];
            imageTypeList.push({
                name: this.$trans(`标准镜像`), //'自定义镜像',
                imageType: 0
            });
            this.imageTypeList = imageTypeList;
            this.imageType = 0;
        }
    }
}
